import React from 'react'
import ProgramBenefits from './../components/ProgramBenefits'
import ProgramFlow from './../components/ProgramFlow'
import FAQ from './../components/FAQ'
// import GetCertified from './../components/GetCertified'
import Recognised from './../components/Recognised'
import Countdown from './../components/Countdown'
// import Countdown2 from './../components/Countdown2'
import Hero from './../components/Hero'
import Testimonials from './../components/Testimonials'
import Achievements from './../components/Achievements'
import WhoSection from '../components/WhoSection'
import Schedule from '../components/Schedule'
import Mentor from '../components/Mentor'
import Skills from '../components/Skills'
import AddScript from '../components/AddScript'

function Home() {
    return (
        <>
            <Hero />
            <Recognised />
            <Countdown />
            {/* <Countdown2 /> */}
            <ProgramBenefits />
            <WhoSection />
            <Skills />
            <Schedule />
            <ProgramFlow />
            <Mentor />
            <Testimonials />
            {/* <GetCertified /> */}
            <Achievements />
            <FAQ />
            {AddScript()}
        </>
    )
}

export default Home
